<template>
  <TaskItemContainer class="dependencies-item">
    <template #content>
      <DependencyStatusPicker
        :disabled="false"
        :open.sync="isDependencyStatusOpen"
        @change-status="onChangeStatus"
        :type="predecessor.type === 'complete' ? 'waiting' : 'blocked'"
      >
        <DependencyStatus
          v-tooltip="{
            content: !isDependencyStatusOpen && $t('Edit dependency'),
            placement: 'top',
          }"
          :type="predecessor.type === 'complete' ? 'waiting' : 'blocked'"
          class="dependencies-item__status"
        />
      </DependencyStatusPicker>
      <TaskItemName @click="selectDependency" :value="predecessorName" />
    </template>
    <template #actions>
      <div v-if="!task || !task.id" style="display: flex">
        <Skeleton
          style="margin: 0 16px"
          width="100"
          height="28"
          radius="50px"
        />
        <Skeleton
          style="margin-right: 16px"
          width="28"
          height="28"
          radius="50%"
        />
      </div>
      <DependenciesItemTask v-else :task="task" />
      <DependencyOptionsMenu
        :open.sync="isOptionsMenuOpen"
        @remove-dependency="removePredecessor"
      >
        <TaskItemOptions
          :tooltip="isOptionsMenuOpen ? $t('Dependnecy Option') : ''"
        />
      </DependencyOptionsMenu>
    </template>
  </TaskItemContainer>
</template>
<script>
import DependencyStatusPicker from '@widgets/DependencyStatusPicker/DependencyStatusPicker';
import { computed } from 'vue-demi';
import DependencyStatus from '@/components/widgets/TaskDetailWidgets/DependencyStatus';
import TaskItemContainer from '../TaskItemContainer';
import TaskItemOptions from '../TaskItemOptions';
import TaskItemName from '../TaskItemName';
import DependencyOptionsMenu from './DependencyOptionsMenu';
import DependenciesItemTask from './DependenciesItemTask';
import Skeleton from '@/components/widgets/Skeleton';
import { useQuickViews } from '@/platform/composables/useQuickViews';

export default {
  name: 'DependenciesItem',
  data() {
    return {
      openDependencyStatusId: 0,
      isDependencyStatusOpen: false,
      isOptionsMenuOpen: false,
    };
  },
  props: {
    predecessor: {
      type: Object,
      required: true,
    },
    task: {
      type: Object,
      required: true,
    },
    selectedTask: {
      type: Object,
      required: true,
    },
    initialItem: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    DependencyStatusPicker,
    DependencyStatus,
    TaskItemContainer,
    TaskItemOptions,
    TaskItemName,
    Skeleton,
    DependenciesItemTask,
    DependencyOptionsMenu,
  },
  setup(props, { emit }) {
    const { replaceQuickView } = useQuickViews();
    function removePredecessor() {
      emit('remove-predecessor', props.predecessor);
    }

    function onChangeStatus(status) {
      emit('edit-predecessor', { ...props.predecessor, type: status });
    }

    function selectDependency() {
      const dependenciesCrumbs = [
        ...(this.initialItem?.dependenciesCrumbs?.length
          ? this.initialItem.dependenciesCrumbs
          : []),
        {
          id: this.selectedTask.id,
          text: this.selectedTask.name,
        },
      ];

      if (props.task?.id) {
        replaceQuickView({
          type: 'task',
          id: props.task.id,
          initialItem: {
            ...props.task,
            dependenciesCrumbs,
          },
        });
      }
    }

    const predecessorName = computed(() => props.predecessor.name || '');

    return {
      removePredecessor,
      onChangeStatus,
      selectDependency,
      predecessorName,
    };
  },
};
</script>
<style lang="scss" scoped>
.dependencies-item {
  &__status {
    margin-right: 8px;
    margin-left: 24px;
  }
}
</style>
